<template>
    <v-app>
        <weekend-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Weekend List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                        <v-col lg="3" md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col lg="5" md="4" cols="12">
                                            <div class="d-flex align-center justify-center pr-2">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col lg="4" md="4" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openAddShift"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Weekend
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import weekendSetup from '@/components/module/attendance/settingsManagement/weekendSetup.vue';
import formattedDate from '@/plugins/dateFormatter';


export default {
        components: {
            weekendSetup
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Code", key: "code", align: "left" ,sortable: false },
                { title: "Name", key: "name", align: "left" ,sortable: false },
                { title: "Days", key: "daysLabel", align: "left" ,sortable: false },
                { title: "Weekend", key: "weeksLabel", align: "left" ,sortable: false },
                { title: "Departments", key: "departmentsLabel", align: "left" ,sortable: false },
                { title: "Shifts", key: "shiftsLabel", align: "left" ,sortable: false },
                { title: "Start Date", key: "start_date_label", align: "center" ,sortable: false },
                { title: "End Date", key: "end_date_label", align: "center" ,sortable: false },
                { title: "Remarks", align: "left", key: "remarks", sortable: false },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
    created() {
        // if(this.$store.getters.getWeekendList.length == 0){
            this.loading = true;
            this.$store.dispatch('getWeekendList').then((response) => {
                this.loading = false;
            })
        // };
        },
        computed:{
            getSchema() {
                const list = this.$store.getters.getWeekendList || [];
                return list.map((item) => {
                    const days = this.normalizeArray(item, ['days', 'weekend_days', 'day_names', 'day'], ['day_name', 'name', 'day']);
                    const departments = this.normalizeArray(item, ['departments', 'department_names', 'department'], ['department_name', 'name']);
                    const shifts = this.normalizeArray(item, ['shifts', 'shift_names', 'shift'], ['shift_name', 'name']);
                    const startDate = item.start_date || item.startDate || "";
                    const endDate = item.end_date || item.endDate || "";

                    return {
                        ...item,
                        weeksLabel: this.formatWeeks(item.weeks), // 👈 ADD THIS
                        code: item.code || item.weekend_code || "-",
                        name: item.name || item.title || item.year || "-",
                        start_date: startDate,
                        end_date: endDate,
                        start_date_label: new Date(startDate).toLocaleDateString('en-GB'),
                        end_date_label: endDate
                        ? new Date(endDate).toLocaleDateString('en-GB')
                        : 'Continued',
                        daysLabel: this.formatItemsForLabel(days),
                        departmentsLabel: this.formatItemsForLabel(departments),
                        shiftsLabel: this.formatItemsForLabel(shifts),
                    };
                });
            },
        },
        methods: {
            formattedDate,
            openAddShift() {
                this.data = {
                    weekend_id : '', 
                    name: '',
                    day_ids: [],
                    department_ids: [],
                    shift_ids: [],
                    start_date: '',
                    end_date: '',
                    remarks: '',
                    status: 1,
                };
                this.dialog = true;
            },
            editItem(item){
                const dayIds = this.extractIds(item, ['day_ids', 'days', 'weekend_days'], ['day_id', 'id']);
                const departmentIds = this.extractIds(item, ['department_ids', 'departments'], ['department_id', 'id']);
                const shiftIds = this.extractIds(item, ['shift_ids', 'shifts'], ['shift_id', 'id']);

                this.data = {
                    weekend_id: item.id || item.weekend_id || '',
                    name: item.name || '',
                    day_ids: dayIds,
                    department_ids: departmentIds,
                    shift_ids: shiftIds,
                    weeks: item['weeks'],
                    start_date: item.start_date || '',
                    end_date: item.end_date || '',
                    remarks: item.remarks || '',
                    status: item.status ?? 1,
                };
                this.dialog = true;
            },
            normalizeArray(item, possibleKeys = [], valueKeys = []) {
                for (const key of possibleKeys) {
                    const value = item?.[key];
                    if (Array.isArray(value)) {
                        return value.map((entry) => {
                            if (typeof entry === "string") {
                                return { label: entry };
                            }
                            if (typeof entry === "object" && entry !== null) {
                                for (const valueKey of valueKeys) {
                                    if (entry[valueKey]) {
                                        return { label: entry[valueKey] };
                                    }
                                }
                                if (entry.name) {
                                    return { label: entry.name };
                                }
                            }
                            return { label: String(entry ?? "") };
                        });
                    }
                    if (typeof value === "string") {
                        return value.split(",").map((entry) => ({ label: entry.trim() }));
                    }
                }
                return [];
            },
            ordinal(n) {
                if (n >= 11 && n <= 13) return n + "th";

                switch (n % 10) {
                    case 1: return n + "st";
                    case 2: return n + "nd";
                    case 3: return n + "rd";
                    default: return n + "th";
                }
            },


            formatWeeks(weeks) {
                if (!Array.isArray(weeks) || weeks.length === 0) {
                    return "Every Weekend";
                }

                return weeks
                    .map(w => this.ordinal(w.week_no))
                    .filter(Boolean)
                    .join(", ");
            },
            formatItemsForLabel(items) {
                if (!Array.isArray(items) || items.length === 0) {
                    return "All";
                }
                return items
                    .map((entry) => entry?.label)
                    .filter(Boolean)
                    .join(", ");
            },
            extractIds(item, possibleKeys = [], idKeys = []) {
                for (const key of possibleKeys) {
                    const value = item?.[key];
                    if (Array.isArray(value)) {
                        return value
                            .map((entry) => {
                                if (typeof entry === "number" || typeof entry === "string") {
                                    return entry;
                                }
                                if (typeof entry === "object" && entry !== null) {
                                    for (const idKey of idKeys) {
                                        if (entry[idKey] !== undefined) {
                                            return entry[idKey];
                                        }
                                    }
                                }
                                return null;
                            })
                            .filter((entry) => entry !== null && entry !== undefined);
                    }
                }
                return [];
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Name', 'Days', 'Departments', 'Shifts', 'Start Date', 'End Date', 'Remarks', 'Status'];
                const rows = this.getSchema.map(item => [
                    serialNumber++,
                    item.code,
                    item.name,
                    item.daysLabel,
                    item.departmentsLabel,
                    item.shiftsLabel,
                    item.start_date_label || '-',
                    item.end_date_label || '-',
                    item.remarks || '-',
                    item.status == 1 ? 'Active' : 'Inactive',
                ]);
                this.$exportTableToPDF(columns,rows,'Weekend List','weekend_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Code', 'Name', 'Days', 'Departments', 'Shifts', 'Start Date', 'End Date', 'Remarks', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([
                        serialNumber++,
                        item.code,
                        item.name,
                        item.daysLabel,
                        item.departmentsLabel,
                        item.shiftsLabel,
                        item.start_date_label || '-',
                        item.end_date_label || '-',
                        item.remarks || '-',
                        item.status == 1 ? 'Active' : 'Inactive',
                    ]);
                });
                this.$exportTableToExcel(data,'weekend_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Code', 'Name', 'Days', 'Departments', 'Shifts', 'Start Date', 'End Date', 'Remarks', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([
                        serialNumber++,
                        item.code,
                        item.name,
                        item.daysLabel,
                        item.departmentsLabel,
                        item.shiftsLabel,
                        item.start_date_label || '-',
                        item.end_date_label || '-',
                        item.remarks || '-',
                        item.status == 1 ? 'Active' : 'Inactive',
                    ]);
                });

                this.$exportTableToCSV(data,'weekend_list_' + this.$fileDate());
            },
            formatDateTime(dateTime) {
                if (!dateTime) {
                    return "-";
                }
                const d = new Date(dateTime);
                if (isNaN(d.getTime())) {
                    return "-";
                }
                return `${this.formattedDate(dateTime)} ${d.toLocaleTimeString()}`;
            },
        },
        mounted() {

        }  
    }
</script>